/* eslint react/prop-types: 0 */
import React from 'react';
import PropTypes from 'prop-types';
import { compose, setPropTypes, setDisplayName } from 'recompose';
import styles from './PaymentTitle.scss';

const PaymentTitle = ({ children }) => (
  <span className={styles.root}>{children}</span>
);


export default compose(
  setDisplayName('PaymentTitle'),
  setPropTypes({
    children: PropTypes.string.isRequired,
  }),
)(PaymentTitle);
